<template>
  <v-card>
    <div class="d-flex justify-content-between align-items-center mt-3 p-3">
      <div class="title">
        <h1>Penilaian Sosiometri</h1>
      </div>
      <div class="toolbar mb-2">
        <ButtonComponent colors="#3751E4" name="tambah" title="Tambah" v-b-modal.modal-penilaian-sosiometri
          @click.native="openModal('Tambah')" style="z-index: 2;"></ButtonComponent>
      </div>
    </div>
    <div class="p-3">
      <b-form>
        <b-form-group label="Pilih Prodi :">
          <Select2 v-model="myValue" :options="prodiOptions"
            :settings="{ settingOption: value, multiple: false, width: '50%' }" @change="myChangeEvent($event)"
            @select="mySelectEvent($event)" />
        </b-form-group>
      </b-form>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="border-radius: 10px; width: 424px; height: 64px; background: #3751E4;">
        <div style="color: #FFFFFF;">
          <span style="font-weight: 600; font-size: 10px; margin-left: 20px;">Siswa dengan nilai tertinggi :</span>
          <br>
          <div class="row">
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 300; font-size: 15px; margin-left: 20px;">Akbar Abdullah</span>
            </div>
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 600; font-size: 30px; margin-right: 20px; float: right;">3.99</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card ml-10" style="border-radius: 10px; width: 424px; height: 64px; background: #3751E4;">
        <div style="color: #FFFFFF;">
          <span style="font-weight: 600; font-size: 10px; margin-left: 20px;">Siswa dengan nilai akademik tertinggi
            :</span>
          <br>
          <div class="row">
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 300; font-size: 15px; margin-left: 20px;">Dedy Obet</span>
            </div>
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 600; font-size: 30px; margin-right: 20px; float: right;">3.98</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="border-radius: 10px; width: 424px; height: 64px; background: #3751E4;">
        <div style="color: #FFFFFF;">
          <span style="font-weight: 600; font-size: 10px; margin-left: 20px;">Siswa dengan nilai kerjasama tertinggi
            :</span>
          <br>
          <div class="row">
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 300; font-size: 15px; margin-left: 20px;">Akbar Abdullah</span>
            </div>
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 600; font-size: 30px; margin-right: 20px; float: right;">3.99</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card ml-10" style="border-radius: 10px; width: 424px; height: 64px; background: #3751E4;">
        <div style="color: #FFFFFF;">
          <span style="font-weight: 600; font-size: 10px; margin-left: 20px;">Siswa dengan nilai pemimpin tertinggi
            :</span>
          <br>
          <div class="row">
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 300; font-size: 15px; margin-left: 20px;">Dedy Obet</span>
            </div>
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 600; font-size: 30px; margin-right: 20px; float: right;">3.98</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <div class="card" style="border-radius: 10px; width: 424px; height: 64px; background: #3751E4;">
        <div style="color: #FFFFFF;">
          <span style="font-weight: 600; font-size: 10px; margin-left: 20px;">Siswa dengan nilai pertemanan tertinggi
            :</span>
          <br>
          <div class="row">
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 300; font-size: 15px; margin-left: 20px;">Akbar Abdullah</span>
            </div>
            <div class="col-md-6" style="margin-top: auto; margin-bottom: auto;">
              <span style="font-weight: 600; font-size: 30px; margin-right: 20px; float: right;">3.99</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="PenilaianSosiometri.search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="PenilaianSosiometri.headers" :items="PenilaianSosiometri.isi_data"
      :search="PenilaianSosiometri.search">
      <template v-slot:header>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th colspan="4">
              <center>Aspek Sosiometri</center>
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
      </template>
      <template v-slot:item.action="{ item }">
        <ButtonComponent colors="#3751E4" name="edit" title="Edit" v-b-modal.modal-penilaian-sosiometri
          @click.native="openModal('Edit')"></ButtonComponent>
        <ButtonComponent colors="#EF4848" name="hapus" title="Hapus"></ButtonComponent>
      </template>
    </v-data-table>

    <b-modal id="modal-penilaian-sosiometri" size="lg" :title="`${statusModal} Penilaian Sosiometri`" ok-title="Simpan"
      ok-variant="primary" cancel-title="Batal" cancel-variant="danger">
      <b-form>
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="NRP">
              <b-form-input id="nrp" type="text" required placeholder="Masukkan NRP"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Nama">
              <b-form-input id="nama" type="text" required placeholder="Masukkan nama"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Akademik">
              <b-form-input id="akademik" type="text" required placeholder="Masukkan akademik"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Kerjasama">
              <b-form-input id="kerjasama" type="text" required placeholder="Masukkan data kerjasama"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Pemimpin">
              <b-form-input id="pemimpin" type="text" required placeholder="Masukkan pemimpin"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Pertemanan">
              <b-form-input id="pertemanan" type="text" required placeholder="Masukkan pertemanan"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <b-form-group label="Nilai Akhir">
              <b-form-input id="nilai_akhir" type="text" required placeholder="Masukkan nilai akhir"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </b-form>
    </b-modal>
  </v-card>
</template>

<script>
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";

export default {
  data() {
    return {
      myValue: '',
      prodiOptions: [
        { id: 'a', text: 'DIKREG' },
        { id: 'b', text: 'DIKMATRA' },
        { id: 'c', text: 'SUSJEMESTRA' }
      ],
      PenilaianSosiometri: {
        headers: [
          { text: "No", align: "center", value: "no", sortable: false },
          { text: "NRP", align: "center", value: "nrp" },
          { text: "Nama", align: "center", value: "nama" },
          { text: "Akademik", align: "center", value: "akademik" },
          { text: "Kerjasama", align: "center", value: "kerjasama" },
          { text: "Pemimpin", align: "center", value: "pemimpin" },
          { text: "Pertemanan", align: "center", value: "pertemanan" },
          { text: "Nilai Akhir", align: "center", value: "nilai_akhir" },
          { text: "Aksi", align: "center", value: "action", sortable: false }
        ],
        isi_data: [
          {
            no: 1,
            nrp: 15453,
            nama: "Akbar Abdullah",
            akademik: 3.5,
            kerjasama: 3.5,
            pemimpin: 3.5,
            pertemanan: 3.5,
            nilai_akhir: 3.99
          },
          {
            no: 2,
            nrp: 15454,
            nama: "Dedy Obet",
            akademik: 3.2,
            kerjasama: 3.2,
            pemimpin: 3.4,
            pertemanan: 3.4,
            nilai_akhir: 3.98
          },
          {
            no: 3,
            nrp: 15455,
            nama: "Wijoyo Danuasmoro",
            akademik: 3.3,
            kerjasama: 3.1,
            pemimpin: 3.5,
            pertemanan: 3.0,
            nilai_akhir: 3.78
          }
        ]
      },
      statusModal: ''
    };
  },
  components: {
    Select2,
    ButtonComponent
  },
  methods: {
    openModal(status) {
      this.statusModal = status;
    }
  }
}
</script>